import { create } from "zustand";

export const useStore = create((set, get) => ({
  lenis: undefined,
  setLenis: (lenis) => set({ lenis }),
}));

const initialState = {
  count: 1,
};

export const useCountStore = create((set, get) => ({
  ...initialState,
  actions: {
    increase: () => set((state) => ({ count: state.count + 1 })),
    decrease: () => set((state) => ({ count: state.count - 1 })),
    resetState: () => set(initialState),
  },
}));
